import { Tag, Tags } from '../interfaces';

const findQuestion = (id: string, questions?: Tag[]) => {
  const questionId = id.split(':')[1];

  return questions?.find((q) => q.id?.toString() === questionId);
};

const getData = (id: string, value: Tags[0], questions?: Tag[]) => {
  const question = findQuestion(id, questions);
  const valueId = value.toString().split(':')[1];
  const answer = question?.enum_variants?.find((v) => v.id === value || v.id.toString() === valueId);

  return { question, answer };
};

export const tagDescription = (id: string, value: Tags[0], questions?: Tag[]) => {
  const { question, answer } = getData(id, value, questions);
  const namePrefix = question?.name ? `${question.name}: ` : '';
  return `${namePrefix}${answer?.variant_name || value}`;
};

export const tagAnswer = (id: string, value: Tags[0], questions?: Tag[]) => {
  const { answer } = getData(id, value, questions);

  return `${answer?.variant_name || value}`;
};

/**
 * Resolves a 'td:<id>' tag key to its definition's stable identifier, which is what
 * identifier-keyed lookups match on. Returns undefined while the tag vocabulary is still loading
 * or when the definition is unknown, so callers degrade rather than throw.
 */
export const tagDefIdentifier = (id: string, questions?: Tag[]): string | undefined =>
  findQuestion(id, questions)?.identifier;
